import { render, staticRenderFns } from "./OcorrenciaTransito.vue?vue&type=template&id=09c5055f&scoped=true"
import script from "./OcorrenciaTransito.vue?vue&type=script&lang=js"
export * from "./OcorrenciaTransito.vue?vue&type=script&lang=js"
import style0 from "./OcorrenciaTransito.vue?vue&type=style&index=0&id=09c5055f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c5055f",
  null
  
)

export default component.exports